export AirForce from './AirForce.svg'
export BOA from './BOA.svg'
export Hilton from './Hilton.svg'
export Hyatt from './Hyatt.svg'
export Marriott from './Marriott.svg'
export OmniHotels from './OmniHotels.svg'
export Trump from './Trump.svg'
export USGov from './USgov.svg'


// WEBPACK FOOTER //
// ./src/assets/logos.js